export { default } from './ApplicationDiff';
